var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,6.887H9.113V1H6.887V6.887H1V9.113H6.887V15H9.113V9.113H15Z",
    transform: "translate(-1 -1)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus-small.9ce8dac450c2ab39ec58c2862c5e5bc4.svg";